// sagas/index.js
import { all } from 'redux-saga/effects';
import versionSaga from './latestVersion/saga';
import drawerMenuSaga from "./drawerMenu/saga";
import bannerSaga from "./Banner/saga";
import productListSaga from "./ProductList/saga";
import colorListSaga from "./ColorList/saga";
import spaceListSaga from "./SpaceList/saga";
import totalCountSaga from "./TotalCount/saga";
import productModalDataSaga from "./ProductModalData/saga";
import showMoreProductSaga from "./ShowMoreProduct/saga";
import licenceSaga from "./Licence/saga";
import likeSaga from "./LikeForm/saga";
import dislikeSaga from "./DislikeForm/saga";
import showMoreCollectionSaga from './ShowMoreCollection/saga';
import likeCollectionSaga from './LikeCollection/saga';
import dislikeCollectionSaga from './DislikeCollection/saga';
import collectionModalDataSaga from './CollectionModalData/saga';
import authSaga  from './auth/saga';
import singleBannerSaga from './SingleCollectionBanner/saga';
import profileSaga from './Profile/saga';
import singleCategoryFileSaga from './SingleCollectionCategory/saga';
import favoriteFilesSaga from './FavoriteFiles/saga';
import favoriteCollectionSaga from './FavoriteCollection/saga';
import activeLicenseSaga from './ActiveLicense/saga';
import forgetPasswordSaga from './ForgetPassword/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        versionSaga(),
        drawerMenuSaga(),
        bannerSaga(),
        productListSaga(),
        colorListSaga(),
        spaceListSaga(),
        totalCountSaga(),
        productModalDataSaga(),
        showMoreProductSaga(),
        licenceSaga(),
        likeSaga(),
        dislikeSaga(),
        showMoreCollectionSaga(),
        likeCollectionSaga(),
        dislikeCollectionSaga(),
        collectionModalDataSaga(),
        singleBannerSaga(),
        profileSaga(),
        singleCategoryFileSaga(),
        favoriteFilesSaga(),
        favoriteCollectionSaga(),
        activeLicenseSaga(),
        forgetPasswordSaga(),
    ]);
}
